import { chartGridPositions } from '../../../../../shared/constants/chart';

interface ChartXAxisLabelProps {
  isChartScrollable: boolean;
}

function ChartXAxisLabel({ isChartScrollable }: ChartXAxisLabelProps) {
  return (
    <div
      className={`absolute -bottom-6 flex w-full gap-x-4 ${isChartScrollable && 'right-2'}`}
    >
      <span className="w-[131px]" />
      <div className="text-black-700 relative w-full text-xs">
        {chartGridPositions.map((val) => {
          const style =
            val === 100
              ? {
                  left: '100%',
                  transform: isChartScrollable ? 'translateX(-50%)' : undefined,
                }
              : { left: `${val}%` };
          return (
            <div
              key={val}
              className={`absolute -translate-x-1/2 ${isChartScrollable && 'translate-x-0'}`}
              style={style}
            >
              {val}
            </div>
          );
        })}
      </div>
      <span className="w-[180px]" />
    </div>
  );
}
export default ChartXAxisLabel;
